// A previous dismissal does not prove the user has discovered the dock.
const DOCK_USED_KEY = 'onboarding_dock_used_v1';
let usedThisSession = false;

export function hasCompletedOnboarding(): boolean {
  if (usedThisSession) return true;
  try { return localStorage.getItem(DOCK_USED_KEY) === 'true'; }
  catch { return false; }
}

export function recordOnboardingDockUse(): void {
  usedThisSession = true;
  try { localStorage.setItem(DOCK_USED_KEY, 'true'); } catch { /* Still remember this session. */ }
}

export function resetOnboarding(): void {
  usedThisSession = false;
  try { localStorage.removeItem(DOCK_USED_KEY); } catch { /* Storage may be unavailable. */ }
}
